import React from 'react';
import PropTypes from 'prop-types';

import Icon, { ICON_NAMES } from 'components/Icon';


function RadioMarker(props) {
  const { className, isChecked } = props;

  return (
    <span className={`checkbox-marker`}>
      <Icon name={ICON_NAMES.radio} active={isChecked} className={isChecked ? 'icon-radio icon-radio--active' : 'icon-radio'} />
    </span>
  )
}


RadioMarker.defaultProps = {
  className: ''
}

RadioMarker.propTypes = {
  isChecked: PropTypes.bool,
  className: PropTypes.string
}


export default RadioMarker;